// Shared helpers for the season pricing tier formset, used by both the
// create flow (AddSeasonModal) and the edit flow (EditRegistrationModal).

export const emptyTier = (index) => ({
    name: `Tier ${index + 1}`,
    start_date: "",
    end_date: "",
    fee: "",
});

/**
 * Mirrors the server-side tier rules so the user gets feedback without a round
 * trip. ISO date strings compare correctly as plain strings.
 * Returns an array of {field: message} positionally aligned with `tiers`.
 */
export const validateTiers = (tiers, regStart, regDeadline) => {
    const rowErrors = tiers.map(() => ({}));

    tiers.forEach((tier, index) => {
        if (!tier.name.trim()) {
            rowErrors[index].name = "Required.";
        }
        if (!tier.start_date) {
            rowErrors[index].start_date = "Required.";
        }
        if (!tier.end_date) {
            rowErrors[index].end_date = "Required.";
        }
        if (tier.fee === "") {
            rowErrors[index].fee = "Required.";
        } else if (Number(tier.fee) <= 0) {
            rowErrors[index].fee = "Must be greater than zero.";
        }

        if (tier.start_date && tier.end_date && tier.start_date > tier.end_date) {
            rowErrors[index].end_date = "Must be on or after the start date.";
        }
        if (regStart && tier.start_date && tier.start_date < regStart) {
            rowErrors[index].start_date = "Must be on or after the registration start date.";
        }
        if (regDeadline && tier.end_date && tier.end_date > regDeadline) {
            rowErrors[index].end_date = "Must be on or before the registration deadline.";
        }
    });

    // Compare in date order, but report against the row's original position.
    const ordered = tiers
        .map((tier, index) => ({ tier, index }))
        .filter(({ tier }) => tier.start_date && tier.end_date)
        .sort((a, b) => (a.tier.start_date < b.tier.start_date ? -1 : 1));

    for (let i = 1; i < ordered.length; i += 1) {
        const previous = ordered[i - 1];
        const current = ordered[i];
        if (current.tier.start_date <= previous.tier.end_date) {
            rowErrors[current.index].start_date = `Overlaps the "${previous.tier.name}" tier.`;
        }
    }

    return rowErrors;
};

/** True when any row in a validateTiers() result carries an error. */
export const hasTierErrors = (rowErrors) => rowErrors.some((row) => Object.keys(row).length > 0);
